import Vue from 'vue'
import VueRouter from 'vue-router'
import SASS from './assets/CSS/main.sass'
import Modal from './components/Modal.vue'
import ModalOK from './components/ModalOK.vue'
import ModalQR from './components/ModalQR.vue'
import ModalVerifyCode from './components/ModalVerifyCode.vue'
import ModalLogin from './components/ModalLogin.vue'
import ModalEditSlink from './components/ModalEditSlink.vue'
import ModalAddRemPack from './components/ModalAddRemPack.vue'
import ModalAddRemSubscr from './components/ModalAddRemSubscr.vue'
import VeeValidate from 'vee-validate'
import CartOverlay from './components/cartOverlay.vue'
import Home from './pages/Home.vue'
import FAQ from './pages/FAQ.vue'
import Get from './pages/Get.vue'
import p404 from './pages/p404.vue'
import MngSub from './pages/MngSub.vue'
import About from './pages/About.vue'
import Links from './pages/Links.vue'
import AccSettings from './pages/AccSettings.vue'
import SubsUpdate from './pages/SubsUpdate.vue'
import Checkout from './pages/Checkout.vue'
import Contact from './pages/Contact.vue'
import Metrics from './pages/Metrics.vue'
import Mng from './pages/Mng.vue'
import Subscriptions from './pages/Subscriptions.vue'
import MngDetail from './pages/MngDetail.vue'
/* import MngDetail2 from './pages/MngDetail2.vue' */
import ModalEdit from './components/ModalEdit.vue'
import Orders from './pages/Orders.vue'
import PmtSrc from './pages/PmtSrc.vue'
import Pmt from './pages/Pmt.vue'
import Terms from './pages/Terms.vue'
import Activate from './pages/Activate.vue'
import Privacy from './pages/Privacy.vue'
import Try from './pages/Try.vue'
import Videos from './pages/Videos.vue'
import Forgot from './pages/Forgot.vue'
import Verified from './pages/Verified.vue'
import Unverified from './pages/Unverified.vue'
import Register from './pages/Register.vue'
import AddBrand from './pages/AddBrand.vue'
import Trial from './pages/Trial.vue'
//import AudioAds from './pages/PROMO/AudioAds.vue'
import AddWords from './pages/AddWords.vue'
import CompleteReg from './pages/CompleteReg.vue'
import OrderDetails from './pages/OrderDetails.vue'
import Dashboard from './pages/Dashboard.vue'
import { Validator } from 'vee-validate'
import ScriptLoader from './components/ScriptLoader.vue'
import ModalClaims from './components/ModalClaims.vue'
import AZCognito from './components/AZCognito.vue'
import AZapiClient from './components/APIclient.vue'
import PlanChooser from './components/PlanChooser.vue'
import constants from './STATIC/constants'
import { AZEventBus } from './components/AZEventBus.js';
import FullSpinner from './components/FullSpinner'
import Notifications from 'vue-notification'

import AOS from 'aos'
import 'aos/dist/aos.css'

window.mobileAndTabletCheck = function() {
	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
};


import VueToggles from 'vue-toggles';
Vue.component('VueToggles', VueToggles);



require('./helpers/az')

function checkPwd(p) {
	if (p == 'uncrackable') {
		return true
	}
	return false
}

function askForPassword() {
	var local = localStorage.getItem('tok');
	if (local == undefined) {
		let newPassword = prompt('Access');
		if (checkPwd(newPassword)) {
			localStorage.setItem('tok', newPassword);
			return
		} else {
			askForPassword()
		}
	} else {
		if (checkPwd(local)) {
			return
		} else {
			localStorage.setItem('tok', undefined);
			askForPassword();
		}
	}
}
if(process.env.NODE_ENV != 'production')
	askForPassword();

const dictionary = {
	en: {
		attributes: {
			fName: 'First Name',
			lName: 'Last Name',
			email2: 'Confirm Email',
			password2: 'Confirm Password',
			terms: 'Agree to Terms'
		},
		messages: {
			is: () => 'The confirmation does not match'
		}
	}
}
Validator.localize(dictionary)

// Main VUE INSTANCE

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('statusString', function (value) {

	if (!value) return '';

	value = value.toString();

	if (value == constants.status.SlinkExistsNoUrl.longCode) {
		return 'Active - No URL assigned';
	} else if (value == constants.status.SlinkInGracePeriod.longCode) {
		return 'Expired - Please renew';
	} else if (value == constants.status.SlinkPendingCancel.longCode) {
		return 'Canceled - Will not renew'
	} else if(value == constants.status.SlinkActive.longCode){
		return 'Active'
	}
})

Vue.filter('actionString', function (value) {

	if (!value) return '';

	value = value.toString();

	if (value == constants.status.SlinkPendingCancel.longCode) {
		return 'Will be removed:'
	} else if(value == constants.status.SlinkActive.longCode || value == constants.status.SlinkExistsNoUrl.longCode){
		return 'Renews'
	}
})



Vue.config.productionTip = false
Vue.use(VeeValidate) 
Vue.use(VueRouter)
Vue.use(Notifications)


//Vue.use(Numeral)

const app = new Vue({
	el: '#app',
	components: {
		Modal,
		ModalOK,
		ModalLogin,
		ModalVerifyCode,
		CartOverlay,
		ScriptLoader,
		AZCognito,
		AZapiClient,
		ModalEditSlink,
		ModalAddRemPack,
		ModalAddRemSubscr,
		FullSpinner,
		ModalClaims,
		AOS,
		ModalQR,
		ModalEdit,
		PlanChooser
	},
	data: {
		showSlinkAvail: false,
		showSubs: false,
		slink: '',
		cartContents: [],
		isAuth: false,
		showModal: false,
		loadedModalComponent: 'ModalOK',
		modalPropsObj: { message: '' },
		goAfterLogin: '',
		showCart: false,
		asyncScripts: [],
		subOptions: [],
		slinkForSubOptions: '',
		//USER_POOL: {},
		userAttrs: {},
		apiUrl: 'https://' + process.env.HOST + '/',
		comp2: CartOverlay,
		creds: '',
		doneFederating: false,
		constants: constants,
		timer: '',
		showFullSpinner: false,
		timeOffset: 0,
		showGDPR: true,
		az: az,
		accountType: '',
		pageLoad: false,
		snf: false,
		plans: {free: {limit: 20}, original: {limit: 20}},
		newPlans: {},
		showPlans: false
	},
	computed: {
		cartCount: function () {
			return this.cartContents.length
		},
		cartMenuVisible: function () {
			return az.noSlash(this.$route.fullPath) == '/checkout'
		}
	},
	created: function () {
		// Create the azCognito instance:
		var tempCog = Vue.extend(AZCognito)
		this.azCognito = new tempCog({
			propsData: { owner: this }
		})

		// Create the APIclient instance:
		var tempApiClient = Vue.extend(AZapiClient);
		this.apiClient = new tempApiClient({
			propsData: { owner: this }
		});

		
	},
	mounted: function () {

		var firstLoad = window.location.pathname
		var self = this

		this.startTimer()

		

		AZEventBus.$on('onFederate', msg => {
			self.doneFederating = true;
		});

		setTimeout(function () {
			
			// CHECK SESSION:
			self.azCognito.getUserAttributes(sessionCheckCallback);
			function sessionCheckCallback(result) {
				if (!result) {

				} else {
					// if conditional is true means email is not verified
					if (self.doAuthenticated(result)) {
						self.azCognito.logOutUser(null)
					}
				}
				loadFirstPage();
			}

			function loadFirstPage() {
				// basic 'Loading...' implementation
				
				document.getElementById('app').setAttribute('style', 'display: inline block')
				document.getElementById('loader').setAttribute('style', 'display: none')

				self.$router.push(window.location.pathname + window.location.search)
				AOS.init()

				if(self.$route.query.e){
					self.snf = true
					self.processReturnedFromApi(self.$route.query)
				}

				self.getPlans()
			}

			self.checkGDPR()
		
		}, 1)
	},
	methods: {
		openAccountMenu: function () {
			var el = document.getElementById('accMenu')
			el.classList.toggle('is-active')
			if (el.classList.contains('is-active')) {
				az.hideOnClickOutside('accMenu', ['accMenuTrig'])
			} else {
				if (el == '!accMenu') {
					document.removeEventListener('click', outsideClickListener)
				}
			}
		},
		openCartMenu: function () {
			var el = document.getElementById('cartMenu')
			el.classList.toggle('is-active')
			if (el.classList.contains('is-active')) {
				az.hideOnClickOutside('cartMenu', ['cartMenuTrig', 'cartMenuIcon'])
			} else {
				if (el == '!cartMenu') {
					document.removeEventListener('click', outsideClickListener)
				}
			}
		},
		showModalFullSpinner(){
			this.showFullSpinner = true
		},
		hideModalFullSpinner(){
			this.showFullSpinner = false
		},
		showModalOK: function (obj) {
			this.loadedModalComponent = 'ModalOK'
			this.modalPropsObj = obj
			this.showModal = true
		},
		showModalLogin: function (obj) {
			this.loadedModalComponent = 'ModalLogin'
			this.modalPropsObj = obj
			this.showModal = true
		},
		showModalVerifyCode: function () {
			this.loadedModalComponent = 'ModalVerifyCode'
			this.showModal = true
		},
		showCartOverlay: function () {
			//console.log("called")
			this.showCart = true
		},
		doLogout: function () {
			var self = this

			this.azCognito.logOutUser(logOutCallback)

			function logOutCallback(result) {
				if (result == 'error') {

				} else if (result == 'success') {
					self.isAuth = false


					//clear cart on server
					var cartID = az.getCookie('SlinkCartID');

					function w(){
						az.deleteCookie('SlinkCartID');
						self.cartContents = [];
					}
					function n(){}

					/* if(cartID != undefined && cartID != ''){
						var cartID = az.getCookie('SlinkCartID');
						self.apiClient.delete('api/cart', {}, w, n, null, {'cart-user-id': cartID})
					} */

					if (self.$route.meta.secure) {
						self.$router.push('/')
					}
				}
			}
		},
		loadScript(src, callBack) { // async loader of scripts
			if (!this.asyncScripts.includes(src)) {
				this.asyncScripts.push(src)
				var azScriptLoader = Vue.extend(ScriptLoader)
				this.l = new azScriptLoader({
					propsData: { src: src, callBack: callBack }
				})
			} else {
				callBack()
			}
		},
		successfulAddToCart: function(data, type, slink, planId){
			

			var self = this;
			let c = self.cartContents.findIndex(e => {
				return e.slink == slink
			})
			if(c != -1){
				self.cartContents.splice(c, 1)
			}
			self.cartContents.push(data)
			
			az.addRemSpinner(false, 'class', 'cart')
			
			self.slink = ''
			
			this.$refs.routerView.toSlink = ''

			document.cookie = "SlinkCartID=" + data.cartUserId;
			setTimeout(function () { self.showCart = false }, 3000)
		},
		addToCart: function(type, slink, notused) {

			this.doShowModal('PlanChooser', {item: {type: type, slink: slink}})

			//this.planSelected(type, slink, 'LargeMonthly')
		},
		
		planSelected: function(type, slink, planCode)  {
			


			var self = this
			self.showCart = true
			az.addRemSpinner(true, 'class', 'cart')

			self.worked = function (data, status, statusText, headers, config) {
				if(data.r == 'protected'){
					az.addRemSpinner(false, 'class', 'cart')
					self.showCart = false
					self.showModalOK({ message: 'This word or phrase is protected by trademarks. If you own the trademark for it, please contact claims@slink.com' })
					return
				} 				

				self.successfulAddToCart(data, type, slink, planCode)

			}
			self.noWorked = function (data, status, headers, config, msg, errorRequest) {
				self.showModalOK({ message: 'There was en arror adding to cart, please try again.' })
				//self.cartContents.push(data)
				az.addRemSpinner(false, 'class', 'cart')
				self.showCart = false
			}
			
			var cartID = az.getCookie('SlinkCartID');
			
			self.apiClient.post('api/cart', { 'type': type, 'slink': slink.toLowerCase(), 'code': planCode }, self.worked, self.noWorked, null, {'cart-user-id': cartID})
		},

		planEdited: function(type, slink, planCode, itemId)  {
			var self = this
			self.showCart = true
			az.addRemSpinner(true, 'class', 'cart')

			self.worked = function (data, status, statusText, headers, config) {
				if(data.r == 'protected'){
					az.addRemSpinner(false, 'class', 'cart')
					self.showCart = false
					self.showModalOK({ message: 'This word or phrase is protected by trademarks. If you own the trademark for it, please contact claims@slink.com' })
					return
				} 				

				self.successfulAddToCart(data, type, slink, planCode)

			}
			self.noWorked = function (data, status, headers, config, msg, errorRequest) {
				self.showModalOK({ message: 'There was en arror adding to cart, please try again.' })
				//self.cartContents.push(data)
				az.addRemSpinner(false, 'class', 'cart')
				self.showCart = false
			}
			
			var cartID = az.getCookie('SlinkCartID');
			
			self.apiClient.put('api/cart', { 'type': type, 'slink': slink.toLowerCase(), 'code': planCode }, self.worked, self.noWorked, null, {'cart-user-id': cartID})
		},

		removeFromCart: function (params) {
			var self = this	
			var el = document.getElementsByClassName('cart')
			for (var i = 0; i < el.length; i++) {
				el.item(i).classList.add('is-loading')
			}
			self.worked = function (data) {
				az.removeFromArr(self.cartContents, params)
				for (var i = 0; i < el.length; i++) {
					el.item(i).classList.remove('is-loading')
				}
			}
			self.noWorked = function () {
				self.showModalOK({ message: 'There was en arror deleting from cart, please try again.' })
			}

			var cartID = az.getCookie('SlinkCartID');
			self.apiClient.delete('api/cart/' + encodeURIComponent(params.value), {}, self.worked, self.noWorked, null, {'cart-user-id': cartID})
		},
		doAuthenticated: function (r, fromLogin) {
			this.isAuth = true
			if (this.goAfterLogin != '') {
				this.$router.push(this.goAfterLogin)
				this.goAfterLogin = ''
			}
			if (az.noSlash(this.$route.path) == '/forgot' || az.noSlash(this.$route.path) == '/unverified') {
				this.$router.push('/')
			}

			// parseCognitoUserAttrs:
			var temp = {}
			for (var i = 0; i < r.length; i++) {
				temp[r[i].getName()] = r[i].getValue()
			}
			this.userAttrs = temp

			if ((this.userAttrs.email_verified == 'false') && fromLogin != true) {
				this.isAuth = false
				this.$router.push('/')
				return true
			} else if (this.userAttrs.email_verified == 'false' && fromLogin) {
				this.isAuth = false
				this.$router.push('/')
				this.showModalVerifyCode()
			}
			return false
		},
		processReturnedFromApi: function (obj, fromGet) {
			/* console.log(obj)
			return */
			
			var self = this
			if (obj.e == 'snf' || obj.e == 'spp') {
				if (this.checkSlinkInCart(obj.slink)) {
					self.$root.showModalOK({ message: 'This slink is available and is already in your cart.' })
					return
				} else if(obj.e == 'spp') {
					self.$root.showModalOK({ message: 'This slink is in the process of being purchased by another user. It may become available later if that purchase is not completed.' })
					return
				}

				self.slink = obj.slink
				self.showSubs = false
				self.showSlinkAvail = true

				setTimeout(function(){
					if(self.$refs.routerView && self.$refs.routerView.$refs.gs){
						self.$refs.routerView.$refs.gs.slink = obj.slink
						self.$refs.routerView.$refs.gs.step = 2
					}
						
				}, 4)
				

			} else if (obj.e == 'sbnf') {

				if(decodeURIComponent(obj.slink).split(':')[1] == 'links'){
					self.$router.push('/links/' + obj.slink.split(':')[0])
					return
				} else {
					self.$root.showModalOK({message: `Ths subslink you requested does not exist. Try visiting the slink's SlinkPage to see if other subslinks are being shared... slink.com/${obj.slink.split(':')[0]}:links`})
					return
				}

				self.showSlinkAvail = false
				self.showSubs = true
				if(obj.options.length){
					if(typeof(obj.options) != "string")
						self.subOptions = obj.options;
					else {
						self.subOptions = obj.options.split(',')
					}
				}
				self.slinkForSubOptions = obj.slink.split(':')[0];
			} else if (obj.e == 'gp') {
				self.showModalOK({ message: 'The slink requested is expired. It is still within the renewal grace period. If you are the owner of its subscription, please login and renew your subscription, otherwise it will be released and become agailable soon.' })
			} else if (obj.e == 'nu') {
				self.$root.showModalOK({ message: '<b>Sorry, this slink is already taken, but does not have a url assigned to it.</b><br><br> If you own the subscription to it, please assign a redirect URL to make it functional.' })
			} else if(obj.e == 'prtd'){
				self.doShowModal(ModalClaims, {slink: obj.slink})
				//self.$root.showModalOK({message: 'This word or phrase is available but protected by trademark. If you own the trademark and would like to claim it, please contact claims@slink.com'})
			} else if(obj.e == 'prtdwrd'){
				self.doShowModal(ModalClaims, {slink: obj.slink, wordVariant: true})
				//self.$root.showModalOK({message: 'This word or phrase is available but protected by trademark. If you own the trademark and would like to claim it, please contact claims@slink.com'})
			} else {
				if(!fromGet){
					window.location.href = obj
				} else {
					self.$refs.routerView.$refs.gs.step = 11
				}
			}
		},
		checkSlinkInCart: function (slink) {
			var self = this
			let obj = self.cartContents.find(o => o.item == slink)
			if (obj != undefined) {
				return true
			}
			return false
		},
		startTimer: function(){
			this.timer = new Date();
			this.timer = this.timer.setMinutes(this.timer.getMinutes() + 20);     //setInterval(self.refreshSession, 840000)
		},
		doShowModal: function(component, obj){
			this.modalPropsObj = obj;
			this.loadedModalComponent = component;
			this.showModal = true;
		},
		closeModal: function(){
			this.loadedModalComponent = null
			this.showModal = false;
		},
		setTmOffset: function(tm){
			var d = new Date().getTime()/1000|0
			this.timeOffset = d - tm
		},
		//clear api cache for this slink 
		clearSlinkCache: function(slink){
			this.apiClient.get('api/slink/' + slink, {}, function(){}, function(){}, null, {'Cache-Control': 'max-age=0'})
		},
		checkGDPR: function(){
			var local = localStorage.getItem('gdpr');
			//console.log(local)
			if (local == undefined || local == 'false') {
				//console.log("TRUE")
				this.showGDPR = true
			} else {
				//console.log('FALSE')
				this.showGDPR = false
			}
			
			
		},
		gotIt: function(){
			localStorage.setItem('gdpr', true);
			this.showGDPR = false
		},

		getPlans: function(){


			var self = this;

			function w(d){
				d.plans.forEach(e => {

					self.newPlans[e.code] = e
				})

				self.showPlans = true
				
			}

			function n(){

			}

			this.apiClient.get('api/config/plans', {}, w, n)
			

		}

	},
	router: (() => {
		let router = new VueRouter({
			mode: 'history',
			routes: [
				{ path: '/', component: Home },
				{ path: '/index.html', component: Home },
				{ path: '/get', component: Get },
				//{ path: '/audioads', component: AudioAds },
				{ path: '/videos', component: Videos },
				{ path: '/links/:slink', component: Links },
				{ path: '/orderdetails/:id', name: 'orderdetails', component: OrderDetails, props: true, meta: { secure: true } },
				{ path: '/about', component: About },
				{ path: '/accsettings', component: AccSettings, meta: { secure: true } },
				{ path: '/checkout', component: Checkout, meta: { secure: true } },
				{ path: '/contact', component: Contact },
				{ path: '/dashboard', component: Dashboard, meta: { secure: true } },
				{ path: '/mng', component: Mng, meta: { secure: true } },
				{ path: '/mngdetail', component: MngDetail, name: 'mngdetail', props: true, meta: { secure: true } },
				{ path: '/subscriptions', component: Subscriptions, meta: { secure: true } },
				{ path: '/orders', component: Orders, meta: { secure: true } },
				{ path: '/mngsub', component: MngSub, name: 'mngsub', props: true, meta: { secure: true } },
				{ path: '/p404', component: p404 },
				{ path: '/pmtsrc', component: PmtSrc, name: 'pmtSrc', props: true, meta: { secure: true } },
				{ path: '/metrics/:slink?', component: Metrics, name: 'metrics', props: true, meta: { secure: true } },
				{ path: '/subsupdate', component: SubsUpdate, name: 'subsupdate', props: true, meta: { secure: true } },
				{ path: '/pmt', component: Pmt, meta: { secure: true } },
				{ path: '/register', component: Register },
				{ path: '/try', component: Try, props: true },
				{ path: '/ab', component: AddBrand, meta: { secure: true }  },
				{ path: '/aw', component: AddWords, meta: { secure: true }  },
				{ path: '/terms', component: Terms },
				{ path: '/activate', component: Activate },
				{ path: '/faq', component: FAQ },
				{ path: '/trial', component: Trial },
				{ path: '/privacy', component: Privacy },
				{ path: '/forgot', component: Forgot },
				{ path: '/verified', component: Verified },
				{ path: '/unverified', component: Unverified },
				{ path: '/completereg', component: CompleteReg },
				{ path: '/tk=*', component: Home },
				{ path: '*', component: p404 }
			],
			scrollBehavior: function (to) {
				if (to.hash) {
				  return {
					selector: to.hash
				  }
				}
			  }
		})
		

		router.beforeEach(function (to, from, next) {
			console.log('called')
			// block first load so mounted auth rules can take effect
			if (typeof(router.app) == 'undefined') {
				return
			}
			 
			if (az.noSlash(to.fullPath) == '/register' && router.app.isAuth) {
				router.app.showModalOK({ message: 'If you would like to register a new account, please log out first.' })
				
				router.push('/')
			} else if (to.meta.secure && !router.app.isAuth && to.fullPath != '/') {
				
				router.app.goAfterLogin = to.fullPath
				router.app.showModalLogin({ message: '' })
				router.push('/')
			
			} else {
				window.scrollTo(0, 0)
				next()
			} 
		})

		router.afterEach(function (to, from) {
			var self = this
			document.getElementById('respMenu').classList.remove('is-active');
			document.getElementById('burger').classList.remove('is-active');


			if (to.fullPath.substring(0, 2) == '/?') {
				setTimeout(function () { document.getElementById('homeLink').classList.add('router-link-active') }, 1)
			} else if (from.fullPath.substring(0, 2) == '/?') {
				setTimeout(function () { document.getElementById('homeLink').classList.remove('router-link-active') }, 1)
			}
		

		
			if(process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'testing' && process.env.NODE_ENV !== 'sandbox'){
				if(!router.app.pageLoad){
					router.app.pageLoad = true
				} else {
					gtag('config', 'G-SGXZFL4N3N', {
						page_title: to.path,
						page_path: to.fullPath,
						app_name: 'slink.com',
						send_page_view: true,
					})
				}
			}
		})

		return router
	})()
})
// --//

/// FOR DEV - remove for Prod!
//window.app = app
/// //////////////////////////

// Handle burger visibility and trigger
document.addEventListener('DOMContentLoaded', function () {
	// Get all "navbar-burger" elements
	var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

	// Check if there are any navbar burgers
	if ($navbarBurgers.length > 0) {
		// Add a click event on each of them
		$navbarBurgers.forEach(function ($el) {
			$el.addEventListener('click', function () {
				// Get the target from the "data-target" attribute
				var target = $el.dataset.target
				var $target = document.getElementById(target)

				// Toggle the class on both the "navbar-burger" and the "navbar-menu"
				$el.classList.toggle('is-active')
				$target.classList.toggle('is-active')
			})
		})
	}
})



// WEBPACK FOOTER //
// ./src/main.js